import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../../../../auth/AuthContext";
import { useTranslation } from "react-i18next";
import routes, { dashboardRoute } from "../../../../routes/routes";
import {
  AccountBalance,
  BarChart,
  Lock,
  Settings,
  TableRows,
} from "@mui/icons-material";

const NavigationContext = createContext(null);

export function NavigationProvider({ children }) {
  const { loadingActiveCompany, activeCompany, loadingUser } = useAuth();
  const { t } = useTranslation(["common", "settings", "vault", "navigation"]);

  const keys = [
    "dashboard",
    "reseller",
    "loans",
    "vault",
    "treasury",
    "settings",
  ];

  const pathsMap = {
    dashboard: dashboardRoute,
    reseller: routes.Reseller.clients,
    loans: routes.Financing.loans,
    vault: routes.Vault.root,
    treasury: routes.Treasury.root,
    settings: routes.Settings.profile,
  };

  const iconsMap = {
    dashboard: <TableRows />,
    reseller: <TableRows />,
    loans: <AccountBalance />,
    vault: <Lock />,
    treasury: <BarChart />,
    settings: <Settings />,
  };

  const hiddenMap = {
    dashboard: !activeCompany || activeCompany.is_reseller,
    reseller: !activeCompany || !activeCompany.is_reseller,
    loans: !activeCompany || activeCompany.is_reseller,
    vault: !activeCompany,
    treasury:
      !activeCompany ||
      activeCompany.is_reseller ||
      !activeCompany.has_open_banking,
    settings: false,
  };

  const [elements, setElements] = useState(null);

  const init = () => {
    setElements(
      keys.map((key) => ({
        id: key,
        title: t(`navigation:tabs.${key}.title`),
        subheading: t(`navigation:tabs.${key}.subheading`),
        path: pathsMap[key],
        icon: iconsMap[key],
        hidden: hiddenMap[key],
      })),
    );
  };

  useEffect(() => {
    if (!loadingActiveCompany || !loadingUser) {
      init();
    }
  }, []);

  const value = {
    loading: loadingActiveCompany || loadingUser,
    elements,
  };

  return <NavigationContext value={value}>{children}</NavigationContext>;
}

export function useNavigationContext() {
  return useContext(NavigationContext);
}
